import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UsersService } from 'src/app/core/services';
import { QueryParamsModel } from '../base/models';

@Injectable({ providedIn: 'root' })
export class UserPopulateService {
  constructor(private usersService: UsersService) { }

  populateUser(data: any, displayPropName: string, userIdPropNames: string[]): void;

  populateUser(data: any, displayPropNames: string[], userIdPropNames: string[]): Observable<any>;
  
  populateUser(data: any, displayPropNameOrNames: string | string[], userIdPropNames: string[]): any {
    const userIds = [];
    data.map((key, index) => {
      userIdPropNames.forEach((item) => {
        const a = key[item];
        if (a && userIds.indexOf(a) === -1) {
          userIds.push(a);
        }
      });
    });

    const params = new QueryParamsModel();
    params.all = true;
    params.filter.push('id==' + userIds.join(';'));
    
    const userRequest$ = this.usersService.getUsers(params);
    
    if (typeof displayPropNameOrNames === 'string') {
      userRequest$.subscribe((x) => {
        data.forEach((item: any) => {
          userIdPropNames.forEach((element) => {
            const user = x.results.find((user) => user.id === item[element]);
            item[displayPropNameOrNames] = user ? user.displayName : '';
          });
        });
      });
      return;
    }
    
    return userRequest$.pipe(
      map((x) => {
        data.forEach((item: any) => {
          userIdPropNames.forEach((element, index) => {
            const user = x.results.find((user) => user.id === item[element]);
            item[displayPropNameOrNames[index]] = user ? user.displayName : '';
          });
        });
        return data;
      })
    );
  }
}
